module.exports = __webpack_public_path__ + "img/search.c29838b8.svg";